import * as React from "react";
function TypingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 50",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 25,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: 0.1,
    dur: "1s",
    repeatCount: "indefinite",
    values: "0;1;0"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 25,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: 0.2,
    dur: "1s",
    repeatCount: "indefinite",
    values: "0;1;0"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 25,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: 0.3,
    dur: "1s",
    repeatCount: "indefinite",
    values: "0;1;0"
  })));
}
const ForwardRef = React.forwardRef(TypingIcon);
export default ForwardRef;